<template>
  <v-dialog :value="showRecordForm" @input="v => v || HIDE_RECORD_FORM()" max-width="600px" scrollable>
    <v-card>
      <!-- TITLE -->
      <v-card-title class="primary">
        <span class="headline">{{ editMode ? 'تعديل التصنيف الفرعي' : 'اضافة تصنيف فرعي'}}</span>
      </v-card-title>

      <!-- INPUTS -->
      <v-card-text class="pt-5 pb-0">
        <v-container>
          <v-progress-linear
            v-if="formLoading"
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
          <div v-else>
            <v-text-field
              dense
              outlined
              label="الاسم"
              v-model="form.name"
              :error-messages="errors.name"
            ></v-text-field>
          </div>
        </v-container>
      </v-card-text>

      <!-- ACTIONS -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          dark
          color="primary"
          elevation="1"
          :loading="formLoading"
          @click="editMode ? update(form) : create(form)"
        >حفظ</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'record-form',


  data: function () {
    return {
      form: {},
      errors: {},
      formLoading: false,
    }
  },


  computed: {
    ...mapState(
      'subSections',
      {
        editMode: state => state.editMode,
        showRecordForm: state => state.showRecordForm,
        recordForm: state => {
          return {
            id: state.recordForm.id,
            name: state.recordForm.name
          };
        }
      }
    )
  },


  watch: {
    recordForm(form) { this.form = form; }
  },


  methods: {
    ...mapMutations(
      'subSections',
      [
        'HIDE_RECORD_FORM'
      ]
    ),

    create(form) {
      this.formLoading = true;

      this.$store.dispatch('subSections/create', { form })
        .then((response) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم إضافة تصنيف فرعي بنجاح',
            color: 'success'
          });

          this.$emit('update');
          this.HIDE_RECORD_FORM();
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر إضافة تصنيف فرعي',
            color: 'accent'
          });
        })
        .finally(() => {
          this.formLoading = false;
        });
    },

    update(form) {
      this.formLoading = true;

      this.$store.dispatch('subSections/update', { form })
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم تعديل البيانات بنجاح',
            color: 'success'
          });

          this.$emit('update');
          this.HIDE_RECORD_FORM();
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر تعديل البيانات',
            color: 'accent'
          });
        })
        .finally(() => {
          this.formLoading = false;
        });
    }
  }
}
</script>
